<div class="container mt-4">
  <div class="row">
    <div class="col-md-12">
      <div *ngFor="let t of settings" class="mb-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title">{{ t.name }}</h5>
            <dl class="row">
              <dt class="col-sm-3">{{ settingsI18n?.telephoneI18n }}</dt>
              <dd class="col-sm-9">{{ t.telephone }}</dd>

              <dt class="col-sm-3">{{ settingsI18n?.addressI18n }}</dt>
              <dd class="col-sm-9">{{ t.address }}</dd>

              <dt class="col-sm-3">{{ settingsI18n?.languageI18n }}</dt>
              <dd class="col-sm-9">
                <span *ngIf="t.lang == 'EN'" class="flag-icon flag-icon-us"></span>
               <span *ngIf="t.lang == 'AR'" class="flag-icon flag-icon-ae"></span>
               <span *ngIf="t.lang == 'HN'" class="flag-icon flag-icon-in"></span>
               <span *ngIf="t.lang == 'BN'" class="flag-icon flag-icon-bd"></span>
               {{ showLanguage(t.lang) }}
              </dd>
            </dl>
            <button
              type="button"
              (click)="edit(t.id)"
              type="button"
              data-toggle="modal"
              data-target="#edit"
              class="btn btn-warning btn-sm"
            >
              <i class="fas fa-edit"></i> Edit
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
